import React from 'react';
import CollapsibleCard from 'components/UI/CollapsibleCard';
import TopDestinations from './index';

function Card()
{
    return (
        <CollapsibleCard
            className="tw-w-full"
            title="Top 10 Destinations Sold"
            subtitle="UJV Total Sales."
            storeId="top_destinations"
            defaultState
        >
            <TopDestinations />
        </CollapsibleCard>
    );
}

export default Card;
